import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GlobalContext } from '../../context/GlobalContext';
import { Link } from 'react-router-dom';
import axios from 'axios';

function JobDetail() {
    const { state, functions } = useContext(GlobalContext);
    const { jobDetails, setJobDetails, setLoading } = state;
    const { formatSalary } = functions;
    let { jobId } = useParams();

    useEffect(() => {
        if (jobId !== undefined) {
            setLoading(true);

            axios
                .get(
                    `https://dev-example.sanbercloud.com/api/job-vacancy/${jobId}`
                )
                .then((result) => {
                    let {
                        title,
                        job_description,
                        job_qualification,
                        job_type,
                        job_tenure,
                        job_status,
                        company_name,
                        company_image_url,
                        company_city,
                        salary_min,
                        salary_max,
                    } = result.data;

                    setJobDetails({
                        title: title,
                        job_description: job_description,
                        job_qualification: job_qualification,
                        job_type: job_type,
                        job_tenure: job_tenure,
                        job_status: job_status,
                        company_name: company_name,
                        company_image_url: company_image_url,
                        company_city: company_city,
                        salary_min: salary_min,
                        salary_max: salary_max,
                    });

                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [jobId, setJobDetails, setLoading]);

    return (
        <>
            {jobDetails !== null && (
                <div className='mb-10'>
                    <div className='flex min-h-screen justify-center bg-slate-100'>
                        <div className='my-10 flex h-fit flex-col gap-y-5 rounded-lg bg-white px-7 pt-10 pb-10 shadow-lg md:w-10/12 md:p-14'>
                            <div className='flex justify-between gap-x-5 border-b-2 border-slate-200 pb-9'>
                                <div className='flex gap-x-5 md:gap-x-10'>
                                    <img
                                        src={jobDetails.company_image_url}
                                        alt='logo'
                                        className='h-14 w-14 rounded-full md:h-32 md:w-32'
                                    />
                                    <div className='flex flex-col justify-center'>
                                        <h1 className='text-lg font-bold md:text-3xl'>
                                            {jobDetails.title}
                                        </h1>
                                        <p className='md:text-md text-sm'>
                                            {jobDetails.company_name}
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    {jobDetails.job_status === 0 ? (
                                        <p className='h-fit rounded-md bg-rose-600 py-1 px-3 text-xs text-white md:px-5'>
                                            Closed
                                        </p>
                                    ) : (
                                        <p className='h-fit rounded-md bg-green-500 py-1 px-3 text-xs text-white md:px-5'>
                                            Open
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div>
                                <h1 className='font-semibold'>Description</h1>
                                <p className='md:text-md text-sm'>
                                    {jobDetails.job_description}
                                </p>
                            </div>
                            <div>
                                <h1 className='font-semibold'>Qualification</h1>
                                <p className='md:text-md text-sm'>
                                    {jobDetails.job_qualification}
                                </p>
                            </div>
                            <div>
                                <h1 className='font-semibold'>Job Type</h1>
                                <p className='md:text-md text-sm'>
                                    {jobDetails.job_type}
                                </p>
                            </div>
                            <div>
                                <h1 className='font-semibold'>Job Tenure</h1>
                                <p className='md:text-md text-sm'>
                                    {jobDetails.job_tenure}
                                </p>
                            </div>
                            <div>
                                <h1 className='font-semibold'>City</h1>
                                <p className='md:text-md text-sm'>
                                    {jobDetails.company_city}
                                </p>
                            </div>
                            <div>
                                <h1 className='font-semibold'>Salary</h1>
                                <p className='md:text-md text-sm'>
                                    {formatSalary(jobDetails.salary_min)} -{' '}
                                    {formatSalary(jobDetails.salary_max)}
                                </p>
                            </div>
                            <div>
                                {jobDetails.job_status === 1 ? (
                                    <button
                                        type='button'
                                        className='focus:outline-non mt-5 w-full rounded-lg bg-sky-500 px-7 py-2.5 text-sm font-medium text-white hover:bg-sky-600 focus:ring-4 focus:ring-sky-300'
                                    >
                                        Apply
                                    </button>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-center'>
                        <div className='md:w-10/12'>
                            <Link to={'/'}>
                                <button className='group flex w-fit items-center gap-x-2'>
                                    <svg
                                        className='h-5 w-5 fill-slate-400 transition-all duration-150 group-hover:-translate-x-1'
                                        viewBox='0 0 20 20'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            fillRule='evenodd'
                                            d='M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z'
                                            clipRule='evenodd'
                                        />
                                    </svg>
                                    <p className='font-semibold text-slate-400'>
                                        Back
                                    </p>
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default JobDetail;
